<template>
  <div>
    <v-tooltip bottom open-delay="700">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon small v-bind="attrs" v-on="on" :disabled="disabled" @click="abrirDetalhamentoProduto">
          <slot name="content-activator">
            <v-icon small>mdi-information-outline</v-icon>
          </slot>
        </v-btn>
      </template>
      <span>Abrir tela de Detalhamento do Produto</span>
    </v-tooltip>

    <SysDialog
      v-if="dialog"
      v-model="dialog"
      titulo="Detalhamento do Produto"
      transition="dialog-bottom-transition"
    >
      <template #titulo-append>
        <ConverterEmbalagem dark class="ml-5" />
      </template>

      <div style="margin-top: -1px">
        <CardDetalhesProduto
          :produto="{...produto}" :exibir_raio_x="exibir_raio_x"
          :habilitar_edicao_parametros="habilitar_edicao_parametros"
          :atualizar_detalhes_count="Number(atualizar_detalhes_count) + Number(atualizar_detalhes_count_interno)"
          :ativar_filtro_revenda_direta="ativar_filtro_revenda_direta"
          @update:lote-minimo="ev => reEmitirEvento('update:lote-minimo', ev)"
          @update:tempo-ressuprimento="ev => reEmitirEvento('update:tempo-ressuprimento', ev)"
          @update:influencia-projecao="ev => reEmitirEvento('update:influencia-projecao', ev)"
          @update:cobertura-manual-estoque="ev => reEmitirEvento('update:cobertura-manual-estoque', ev)"
          @update:previsao-gatilho="ev => reEmitirEvento('update:previsao-gatilho', ev)"
          @update:similar="ev => reEmitirEvento('update:similar', ev)"
          @update:heranca="ev => reEmitirEvento('update:heranca', ev)"
          @update:desconsiderar-pedido-em-transito="ev => reEmitirEvento('update:desconsiderar-pedido-em-transito', ev)"
          @update:tipo-projecao-aplicado="ev => reEmitirEvento('update:tipo-projecao-aplicado', ev)"
          @consumos-desconsiderados="atualizar_detalhes_count_interno++"
        />
      </div>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from "../../padraoDeLayout/SysDialogFullScreen";
import CardDetalhesProduto from "./CardDetalhesProduto.vue";
import {mapGetters} from "vuex"
import ConverterEmbalagem from "@/components/compra/Embalagem/ConverterEmbalagem";

export default {
  name: "DetalhesProduto",
  components: {
    ConverterEmbalagem,
    CardDetalhesProduto,
    SysDialog
  },
  props: {
    produto: {
      // Formato: { id_grupo: 0, id_filial: 9999, id_produto: '0', produto_eh_combinacao: false}
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    exibir_raio_x: {
      type: Boolean,
      default: false
    },
    atualizar_detalhes_count: Number,
    habilitar_edicao_parametros: {
      type: Boolean,
      default: false
    },
    ativar_filtro_revenda_direta: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    atualizar_detalhes_count_interno: 0,
  }),
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras"
    }),
  },
  watch: {
    dialog(valor) {
      const jivo = document.getElementsByTagName('jdiv')[0] || null;

      if (!jivo) return;

      if (valor) {
        jivo.setAttribute('style', 'display: none;');
      } else {
        jivo.removeAttribute('style');
      }
    }
  },
  methods: {
    abrirDetalhamentoProduto() {
      this.dialog = ! this.dialog
    },
    reEmitirEvento(nome_evento, dados_evento) {
      this.atualizar_detalhes_count_interno++;
      this.$emit(nome_evento, dados_evento);
      this.$emit("update:parametro-produto", {});
    }
  }
}
</script>

<style scoped>
.dot {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
}
</style>
